// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__ZR8-R","header":"Messages_header__3nvSp"};